import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: 'app-edit-controls',
    templateUrl: './edit-controls.component.html',
    styleUrls: ['./edit-controls.component.scss'],
    standalone: false
})
export class EditControlsComponent {

  origVal?: any;
  @Input() set originalValue(origValue: any) {
    this.origVal = origValue;
    this.valueChange.emit(this.origVal);
  }
  get originalValue() {
    return this.origVal;
  }

  @Input() value?: any;
  @Input() tooltipName = '';
  @Input() editDisabled = false;
  @Input() saveDisabled = false;
  @Input() cancelDisabled = false;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  @Output() valueChange = new EventEmitter<any>();

  editMode = false;

  editClicked() {
    this.onEdit.emit();
    this.editMode = true;
  }

  saveClicked() {
    this.onSave.emit();
  }

  cancelClicked() {
    this.onCancel.emit();
    this.editMode = false;
  }
}
